module.exports = __webpack_public_path__ + "media/images/emblems/Schafisheim-blason-18e89215589a099455d55dcb399637a7.png";